import { render, staticRenderFns } from "./OwnerBusinessesView.vue?vue&type=template&id=a9bd24da&scoped=true&"
import script from "./OwnerBusinessesView.vue?vue&type=script&lang=js&"
export * from "./OwnerBusinessesView.vue?vue&type=script&lang=js&"
import style0 from "./OwnerBusinessesView.vue?vue&type=style&index=0&id=a9bd24da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bd24da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VIcon,VImg})
